export const RANGES = {
    BROR: "bror",
    IVAR: "ivar",
    JONAXEL: "jonaxel",
    BOAXEL: "boaxel",
    AURDAL: "aurdal",
    ELVARLI: "elvarli",
    BYOD: "byod",
    BYODC: "byodc",
    ADDONS_KALLAX: "addons-kallax",
};
export const superSubPlannerObject = {
    algot: [
        RANGES.BROR,
        RANGES.ELVARLI,
        RANGES.AURDAL,
        RANGES.IVAR,
        RANGES.JONAXEL,
        RANGES.BOAXEL,
    ],
    byol: [RANGES.BYOD, RANGES.BYODC],
    "addons-kallax": [RANGES.ADDONS_KALLAX],
};
/**
 * This really should get and find all planners from översätta instead.
 * Otherwise we need to update this file for every new planner that this package will be used in.
 * TBD.
 * @param appId
 * @returns {boolean}
 */
export const plannerExists = (appId) => Object.entries(superSubPlannerObject).some(([_, superPlanner]) => superPlanner.includes(appId));
/**
 * Find subplanner by planner
 * @param appId
 * @returns {string}
 */
export const findSubPlanner = (appId) => {
    for (const key in superSubPlannerObject) {
        if (superSubPlannerObject[key].includes(appId.toLowerCase())) {
            return key;
        }
    }
    return;
};
